export const __EVENT_FEILD_CHANGE__ = '__EVENT_FEILD_CHANGE__'; // 监听字段变化
export const __EVENT_FORM_SUBMIT__ = '__EVENT_FORM_SUBMIT__';// 表单提交事件